var _style, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 318.2",
    style: {
      enableBackground: "new 0 0 512 318.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#005098;}\n\t.st2{fill:#F6A500;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 512,
    height: 318.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "190.9,222.9 212.5,95.8 247.2,95.8 225.5,222.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M351.1,99c-6.9-2.6-17.6-5.3-31-5.3c-34.2,0-58.3,17.2-58.5,41.9c-0.2,18.3,17.2,28.5,30.4,34.5 c13.5,6.2,18,10.2,18,15.8c-0.1,8.5-10.8,12.4-20.7,12.4c-13.9,0-21.2-1.9-32.6-6.7l-4.5-2l-4.9,28.5c8.1,3.5,23,6.6,38.6,6.8 c36.4,0,60-17,60.3-43.4c0.1-14.4-9.1-25.4-29.1-34.5c-12.1-5.9-19.5-9.8-19.5-15.8c0-5.3,6.3-10.9,19.8-10.9 c11.3-0.2,19.5,2.3,25.9,4.9l3.1,1.5L351.1,99L351.1,99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M440,95.9h-26.8c-8.3,0-14.5,2.3-18.1,10.5L343.6,223H380c0,0,5.9-15.7,7.3-19.1c4,0,39.3,0.1,44.4,0.1 c1,4.4,4.2,19,4.2,19H468L440,95.9L440,95.9z M397.2,177.9c2.9-7.3,13.8-35.5,13.8-35.5c-0.2,0.3,2.8-7.4,4.6-12.1l2.3,11 c0,0,6.6,30.3,8,36.7L397.2,177.9L397.2,177.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161.8,95.9l-33.9,86.7l-3.6-17.6c-6.3-20.3-26-42.3-48-53.3l31,111.1h36.6L198.4,96L161.8,95.9L161.8,95.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M96.5,95.8H40.6l-0.4,2.6c43.5,10.5,72.2,35.9,84.1,66.5l-12.1-58.4C110.1,98.5,104,96.1,96.5,95.8L96.5,95.8z "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.c7e4818813fb0b4c43e66f761e4648d8.svg";
export { ForwardRef as ReactComponent };